import { createContext, useContext, useState } from 'react';

const LoginContext = createContext();

const initialState = {
  errorMessage: '',
  isOpenEye: false,
};

const LoginProvider = ({ children }) => {
  const [state, setState] = useState(initialState);

  const updateState = (payload) => setState((prev) => ({ ...prev, ...payload }));
  const resetState = () => setState(initialState);

  return <LoginContext.Provider value={{ updateState, resetState, state }}>{children}</LoginContext.Provider>;
};

export const useLoginState = () => {
  return useContext(LoginContext);
};

export default LoginProvider;
